export default __webpack_public_path__ + "static/media/ic-help.804e2f40.svg";